<div class="need4steel-offerlist-container">
	<div *ngIf="!isLoading && (millOfferList && millOfferList.length === 0)" class="copo-notification-block">
		Sorry, no available offers for now, please come back later...
	</div>
	<div *ngIf="!isLoading && errorDescription" class="copo-notification-block">
		{{ errorDescription }}
	</div>
	<div *ngIf="noWeightOption" class="copo-notification-block" translate>
		need4steel.wizard.no.weight.option.error.message
	</div>
	<div class="copo-offer-display-area">
		<div class="copo-timeline-area copo-timeline-header-area">
			<div class="copo-need4steel-idddescription" *ngIf="!isLoading &&(millOfferList && millOfferList.length>0)">
				{{getIddDescription()}}</div>
			<div class="copo-timeline-row">
				<ng-container *ngFor="let family of families">
					<div class="copo-header-content"
						*ngIf="isFamilyExists(family)">
						{{getFamilyDescription(family)}}
					</div>
				</ng-container>
			</div>
		</div>
		<div class="content-area">
			<div class="copo-timeline-area">
				<div class="copo-timeline-row">
					<ng-container *ngFor="let family of families">
						<div class="copo-timeline-content" *ngIf="isFamilyExists(family)">
							<!-- eslint-disable-next-line @angular-eslint/template/prefer-ngsrc -->
							<img [src]="getImageUrl(family)" alt="" class="copo-product-family-images"
								[matTooltip]="getImageTitle(family)">
						</div>
					</ng-container>
				</div>
			</div>
			<div class="copo-timeline-area" *ngFor="let weekYear of weekYearList">
				<div class="copop-timeline-weekyear">
					<p>W{{weekYear}}</p>
				</div>
				<div class="copo-timeline-row">
					<div class="copo-timeline-content" *ngFor="let millOffers of getMillOffersByWeek(weekYear)">
						<div *ngFor="let millOffer of millOffers">
							<button class="copo-timeline-content-button" mat-flat-button
								*ngIf="millOffer && millOffer.millOffer.millSiteDescription!==''" type="button"
								[routerLink]="['/need4steel/wizard/productSpecification']"
								[state]="{ millOfferId: millOffer.millOffer.id }">
								<span *ngIf="millOffer.millOffer.metalStud" class="copo-timeline-content-button-subtitle copo-padding">
									{{millOffer.millOffer.subCategoryDescription}}</span>
								<span class="copo-timeline-content-button-subtitle">
									{{millOffer.millOffer.millSiteDescription}}</span>
							</button>
						</div>
					</div>
					<ng-container class="copo-timeline-content" *ngIf="getMillOffersByWeek(weekYear).length===0">
						<div class="copo-timeline-content" *ngFor="let item of distinctFamilies"></div>
					</ng-container>
				</div>
			</div>
			<div class="copo-credit-pictures"
				*ngIf="!isLoading && !(millOfferList && millOfferList.length === 0) && !errorDescription && !noWeightOption">
				<a [routerLink]="['/legal-informations']" fragment="credits"
					translate>settings.privacypolicy.creditsforpictures</a>
			</div>
		</div>
	</div>
</div>
<copo-loading-spinner *ngIf="isLoading"></copo-loading-spinner>